export const stylesIcon: React.CSSProperties = {
  cursor: 'pointer',
};
